/* eslint-disable react/display-name, react/no-multi-comp */
import { Rectangle, TooltipProps } from "recharts";
import { CostChartTooltip } from "@/pages/query/Graph";
import { AGGREGATE_OPTIONS } from "./constants";

// Recharts render-callback factories (not React components)

export const createRoundedBarShape =
  (isTopBar: boolean) =>
  (props: unknown): JSX.Element => {
    (props as { radius: number[] }).radius = isTopBar ? [5, 5, 0, 0] : [0, 0, 0, 0];
    return <Rectangle {...(props as Record<string, unknown>)} />;
  };

export const createTooltipContent =
  (aggregateBy: string) =>
  (props: TooltipProps<number, string>): JSX.Element => (
    <CostChartTooltip
      {...props}
      aggregateBy={AGGREGATE_OPTIONS.find(o => o.value === aggregateBy)?.label}
    />
  );
